import React, { useState, useEffect } from 'react';
import './AdminStats.css';
import API_BASE_URL from '../config/api';

const AdminFeedback = () => {
  const [feedbacks, setFeedbacks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchFeedbacks();
  }, []);

  const fetchFeedbacks = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${API_BASE_URL}/api/feedback/all`);
      const data = await res.json();
      if (data.success) {
        setFeedbacks(data.data);
      }
    } catch (error) {
      console.error("Error fetching feedbacks:", error);
    } finally {
      setLoading(false);
    }
  };

  const exportToCSV = () => {
    if (feedbacks.length === 0) return alert("No data to export!");

    const headers = ['Name', 'Email', 'USN', 'Event', 'Q1 (Rating)', 'Q2 (Experience)', 'Q3 (Suggestions)', 'Submitted At'];
    
    const csvRows = feedbacks.map(fb => {
      return [
        fb.name || '',
        fb.email || '',
        fb.usn || '',
        fb.event || '',
        fb.answers?.q1 || '',
        fb.answers?.q2 || '',
        fb.answers?.q3 || '',
        new Date(fb.submittedAt).toLocaleString()
      ].map(value => `"${String(value).replace(/"/g, '""')}"`).join(',');
    });

    const csvContent = [headers.join(','), ...csvRows].join('\n');
    
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', 'participant_feedbacks.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="admin-stats-container">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2>Admin Dashboard - Participant Feedback</h2>
        <button 
          onClick={exportToCSV} 
          style={{ 
            background: '#10b981', 
            color: 'white', 
            border: 'none', 
            padding: '10px 16px', 
            borderRadius: '4px', 
            cursor: 'pointer',
            fontWeight: 'bold',
            fontFamily: `'Alphakind', sans-serif`,
            letterSpacing: '1px'
          }}
        >
          📄 EXPORT TO EXCEL / CSV
        </button>
      </div>
      
      <div className="filters-container">
        <div className="total-count-box">
          Total Feedbacks Received: <strong>{feedbacks.length}</strong>
        </div>
      </div>

      <div className="table-container">
        {loading ? (
          <div className="loading-state">Loading feedbacks...</div>
        ) : (
          <table className="stats-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Email / USN</th>
                <th>Event</th>
                <th>Q1 (Rating)</th>
                <th>Q2 (Experience)</th>
                <th>Q3 (Suggestions)</th>
                <th>Submitted</th>
              </tr>
            </thead>
            <tbody>
              {feedbacks.length > 0 ? (
                feedbacks.map((fb, index) => (
                  <tr key={fb._id}>
                    <td>{index + 1}</td>
                    <td>{fb.name}</td>
                    <td>
                      <div>{fb.email}</div>
                      <div style={{ fontSize: '0.85em', color: '#a0aec0' }}>{fb.usn}</div>
                    </td>
                    <td><span className="event-badge">{fb.event}</span></td>
                    <td>{fb.answers?.q1 || '-'}</td>
                    <td>{fb.answers?.q2 || '-'}</td>
                    <td>{fb.answers?.q3 || '-'}</td>
                    <td>{new Date(fb.submittedAt).toLocaleDateString()}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="no-data">No feedback data found</td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default AdminFeedback;
